<div class="generic-confirm-modal">
  <div class="generic-confirm-modal__header">
    <h3>Participant ID</h3>
  </div>
  <div class="generic-confirm-modal__body id-verify">
    <div class="main-container">
      <div class="left-column">
        <app-select-input
          data-private
          [dataTestId]="'participant-select'"
          [formControlRef]="selectedParticipantId"
          [label]="'Participant'"
          [options]="particpantOptions$ | async"
          (selectionChange)="onParticipantChange()"
        ></app-select-input>
        <label>View: </label>
        <mat-radio-group
          class="left-column__radio-button rkt-Fieldset"
          [(value)]="selectedRadioButton"
          [(ngModel)]="selectedRadioButton"
          (ngModelChange)="viewIdImage()"
          >
          <mat-radio-button class="rkt-Radio" value="1">Front</mat-radio-button>
          <mat-radio-button class="rkt-Radio" value="2">Back</mat-radio-button>
        </mat-radio-group>
      </div>
      @if (idImages$ | async; as idImages) {
        <div class="right-column">
          <div [style]="imageWrapperStyle" #imageWrapper class="right-column__image-wrapper">
            @if (showFrontImage) {
              <img
                data-private
                #idImage
                src="{{ idImages.front }}"
                class="right-column__id-image"
                alt=""
                />
            }
            @if (showBackImage) {
              <img
                data-private
                #idImage
                src="{{ idImages.back }}"
                class="right-column__id-image"
                alt=""
                />
            }
          </div>
          <div class="right-column__rotate-id-image">
            <app-button type="secondary" size="small" (click)="onRotate(idImage.nativeElement)">
              <span class="fas fa-undo-alt"></span>
              <span>Rotate Image</span>
            </app-button>
          </div>
        </div>
      }
    </div>
    <app-button-container>
      <app-button type="primary" (click)="closeModal()" [dataTestId]="'modal-close-id-verify'"
        >Close</app-button
        >
      </app-button-container>
    </div>
  </div>
